module.exports = __webpack_public_path__ + "static/media/la-solid-900.bb49393b.ttf";